<template>
  <div class="likes">
    <i class="fas fa-thumbs-up fa-fw"></i> {{likeTitle}}
    <button class="btn btn-primary float-right" v-on:click="showHideIdea()" type="button" name="button">{{viewHideText}}</button>
    <div v-if="showLike || showLoading" class="mt-4 pt-2 border-top">
      <transition name="grow">
        <Idea v-if="showLike"
          country="http://localhost:50/thinktank/wp-content/uploads/2018/06/flag-south-africa.svg"
          :post-id="idea.id"
          :post-slug="idea.slug"
          :ideaTitle="idea.title.rendered"
          :authorPic="idea._embedded.author[0].avatar_urls['96']"
          :ideaCategories="[]"
          :author="idea._embedded.author[0].name"
          :communityCategories="[]"
          :date="idea.date"
          :content="idea.content.rendered"
          :comments="idea._embedded.replies"
          :likes="idea.total_likes[0]"
          :excerpt="false">
        </Idea>
      </transition>
      <transition name="fade">
        <Loading v-if="showLoading" loading-message="Fetching the idea"></Loading>
      </transition>
    </div>
  </div>
</template>

<script>
import Idea from '@/components/Idea'
import Loading from '@/components/Loading'
import WordpressRestAPI from '@/helpers/WordpressRestAPI.js'
export default {
  components: {
    Idea,
    Loading
  },
  data () {
    return {
      showLike: false,
      ideaLoaded: false,
      showLoading: false
    }
  },
  computed: {
    viewHideText: function () {
      if (this.showLike) {
        return 'Hide idea'
      } else {
        return 'View idea'
      }
    }
  },
  methods: {
    showHideIdea: function () {
      if (!this.ideaLoaded) {
        this.loadIdea()
        this.ideaLoaded = true
      } else {
        this.showLike = !this.showLike
      }
    },
    loadIdea: function () {
      this.showLoading = true
      WordpressRestAPI.getViewContent('idea/' + this.likedPostid + '?_embed=true')
        .then(response => {
          this.idea = response.data
          this.showLike = true
          this.showLoading = false
        })
        .catch(e => {
          this.childContentLoadError = 'Oops! We had a problem with loading your ideas. Please try again later.'
          console.error(e)
        })
    }
  },
  props: [
    'likeTitle',
    'likedPostid'
  ]
}
</script>



// WEBPACK FOOTER //
// src/components/Like.vue